import ValidService from "../../../service/ValidService";
let model = {};

// dữ liệu form
model.dataForm = {
    doi_tuong: null, //string, optional // Đối tượng nhận cảnh báo, nhận một trong hai giá trị sau: kdl, hdv
    co_hieu_luc: false, //boolean, optional // Cho biết cảnh báo có còn hiệu lực hay không
    noi_dung: { //object, optional // Nội dung cảnh báo
        vi: null, //string, optional // Nội dung cảnh báo tiếng Việt
        en: null, //string, optional // Nội dung cảnh báo tiếng Anh
    },
    thu_tu: null, //integer, optional // Thứ tự hiển thị
    tu_ngay: null, //datetime, optional // Ngày có hiệu lực, nếu không có nghĩa là thỏa mãn
    den_ngay: null, //datetime, optional // Ngày hết hiệu lực, nếu không có nghĩa không có hạn
};

// validation form
model.validForm = {
    doi_tuong: [ValidService.required], //string, optional // Đối tượng nhận cảnh báo, nhận một trong hai giá trị sau: kdl, hdv
    co_hieu_luc: [], //boolean, optional // Cho biết cảnh báo có còn hiệu lực hay không
    noi_dung: { //object, optional // Nội dung cảnh báo
        vi: [ValidService.required], //string, optional // Nội dung cảnh báo tiếng Việt
        en: [ValidService.required], //string, optional // Nội dung cảnh báo tiếng Anh
    },
    thu_tu: [], //integer, optional // Thứ tự hiển thị
    tu_ngay: [], //datetime, optional // Ngày có hiệu lực, nếu không có nghĩa là thỏa mãn
    den_ngay: [], //datetime, optional // Ngày hết hiệu lực, nếu không có nghĩa không có hạn

};

// dữ liệu mẫu các form khác
model.dataFormOther = {
    fileUploadOption: {
        AnhDaiDien: {
            limit: 1,
            accept: ".jpg, .png, .jpeg",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: []
        },
        AnhTinTuc: {
            limit: null,
            accept: ".jpg, .png, .jpeg",
            dialogImageUrl: "",
            dialogVisible: false,
            fileList: []
        }
    },

};

// validation các form khác
model.validFormOther = {};

model.trangThai = [{
        code: "true",
        text: "Còn hiệu lực"
    },
    {
        code: "false",
        text: "Không còn hiệu lực"
    }
];

// model.doiTuongNhan = [{
//         code: "kdl",
//         text: "Khách du lịch"
//     },
//     {
//         code: "hdv",
//         text: "Hướng dẫn viên"
//     }
// ];

model.tableRules = {
    data: [],
    lengthMenu: [10, 20, 50, 100, 500],
    allowPaging: true,
    allowSorting: true,
    allowSelect: false,
    showFormSearch: false,
    showUrl: true,
    total: 0,
    page: 1,
    limit: 10,
    offset: 0,
    sort: "",
    defaultSort: ["co_hieu_luc", "descending"],
    filters: "",
    recordSelected: [],
    dataSearch: {
        value: {
            doi_tuong: "",
            co_hieu_luc: "",
            tu_ngay: "",
            den_ngay: "",
        },
        valid: {
            doi_tuong: [],
            co_hieu_luc: [],
        },
        operator: {
            tu_ngay: ":in_that_day:",
            den_ngay: ":in_that_day:"
        }
    }
};

export default model;